import { SelectOption, USER_AFFILIATIONS_OPTIONS } from '@jebel/constants';
import { generateGraduatingYearsOptions } from '@jebel/utils';

import {
  FormSelectDataSource,
  FormSelectDataSourceOption,
  FormSelectDataSourceOptionText,
  FormSelectDataSourceDefinitionProps,
} from '../FormSelectDataSource';

type Props = FormSelectDataSourceDefinitionProps<SelectOption>;

export function SelectAffiliationField(props: Props) {
  const fetchOptions = async (search: string) => {
    return USER_AFFILIATIONS_OPTIONS.filter(option => option.label.includes(search));
  };

  const extractIdentifier = (option: SelectOption) => {
    return option.value as string;
  };

  const extractLabel = (option?: SelectOption) => {
    return option?.label ?? '(UNKNOWN)';
  };

  return (
    <FormSelectDataSource<SelectOption>
      {...props}
      extractIdentifier={extractIdentifier}
      extractLabel={extractLabel}
      fetchOptions={fetchOptions}
    >
      {(params, option) => (
        <FormSelectDataSourceOption {...params} key={option.value}>
          <FormSelectDataSourceOptionText>{option.label}</FormSelectDataSourceOptionText>
        </FormSelectDataSourceOption>
      )}
    </FormSelectDataSource>
  );
}
